import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PUBLIC_API_URL } from '@src/config';
import axios from 'axios';
import toast from 'react-hot-toast';

// Async Thunk to fetch list data from the server
export const fetchListFromServer = createAsyncThunk(
    'newList/fetchListFromServer',
    async (listNumber, { rejectWithValue }) => {
        try {
            toast.loading('Loading your List from server');
            const url = `${PUBLIC_API_URL}/api/listmanager/${listNumber}`;
            const { data } = await axios.get(url);

            toast.dismiss();
            return data.data;
        } catch (error) {
            toast.dismiss();
            return rejectWithValue({ error: error.message });
        }
    }
);

// Initial state
const initialState = {
    table: [],
    listNumber: 0,
    listName: '',
    sidebarValues: {
        oemExcess: true
    },
    isActive: true,
    loading: false,
    selectedRows: new Set(),
    itemsLoaded: 0,
    searchTerm: ''
};

// Slice
const newListSlice = createSlice({
    name: 'newList',
    initialState,
    reducers: {
        setTable: (state, action) => {
            state.table = action.payload;
        },
        setListNumber: (state, action) => {
            state.listNumber = action.payload;
        },
        setListName: (state, action) => {
            state.listName = action.payload;
        },
        setSidebarValues: (state, action) => {
            state.sidebarValues = action.payload;
        },
        setIsActive: (state, action) => {
            // Coerce payload to a strict boolean to guarantee only true/false values
            const status = Boolean(action.payload);
            state.isActive = status;
            state.table = state.table.map((row) => ({
                ...row,
                active: status
            }));
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload;
        },

        setItemsLoaded: (state, action) => {
            state.itemsLoaded = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        resetListState: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchListFromServer.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchListFromServer.fulfilled, (state, action) => {
                state.loading = false;

                // Mapping the response data
                state.table = action.payload.offers;
                state.listName = action.payload.listName;
                state.listNumber = Number(action.payload.listNo);
                state.sidebarValues = {
                    currency: action.payload.currency,
                    listName: action.payload.listName || '',
                    listDescription: action.payload.listDescription,
                    listDate: action.payload.listDate || '',
                    contact: {
                        label: action.payload.contact.label,
                        value: action.payload.contact.value
                    },
                    salesReps: action.payload.salesReps,
                    company: action.payload.company,
                    oemExcess: action.payload.oemExcess
                };
                state.isActive = action.payload.isActive;
            })
            .addCase(fetchListFromServer.rejected, (state, action) => {
                state.loading = false;
                state.listNumber = 0;
            });
    }
});

// Export actions
export const {
    setTable,
    setListNumber,
    setListName,
    setSidebarValues,
    setIsActive,
    setSelectedRows,
    setItemsLoaded,
    setSearchTerm,
    resetListState
} = newListSlice.actions;

// Export reducer
export default newListSlice.reducer;
